.app {
  padding: 0 16px;
}
